import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { __assign, __awaiter, __generator } from "tslib";
import { defineComponent, ref, computed, reactive, nextTick, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ApplyNewService } from '@/services/applyNew.service';
import { UserExamService } from '@/services/userExam.service';
import { LoginService } from '@/services/login.service';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { UserService } from '@/services/user.service';
import { getToken, logger, copyToClipboard, AuthConf, CaptchaAppId, isInIframe } from '@/utils';
import { upperFirst } from 'lodash-es';
import { PersonalComList, SchoolComList } from './fields/applyConf';
import EventBusItemDetail from '@/eventBus/itemDetail';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { getEnvironment } from '@/utils';
// @ts-ignore
var components = require.context('./fields', true, /[a-zA-Z]\w+\.(vue)$/);
var comObj = {};
components.keys().forEach(function (fileName) {
  var _a, _b;
  // 获取文件名
  var filename = (_b = (_a = fileName === null || fileName === void 0 ? void 0 : fileName.split('/')) === null || _a === void 0 ? void 0 : _a.pop()) === null || _b === void 0 ? void 0 : _b.replace(/.\w+$/, '');
  if (filename) {
    // 获取组件配置
    var comp = components(fileName);
    // 若该组件是通过"export default"导出的，优先使用".default"，否则退回到使用模块的根
    var comName = 'Field'.concat(upperFirst(filename));
    comObj[comName] = comp.default || comp;
  }
});
export default defineComponent({
  components: __assign({}, comObj),
  name: 'ApplyFormNew',
  setup: function () {
    var _this = this;
    declareProviders([UserExamService]);
    var userService = useService(UserService);
    var applyService = useService(ApplyNewService);
    var userExamService = useService(UserExamService);
    var loginService = useService(LoginService);
    var route = useRoute();
    var router = useRouter();
    var formRef = ref();
    var isLogin = ref(getToken());
    var loginInfo = reactive({
      visible: false,
      account: '',
      password: ''
    });
    // const params = route.params;
    var env = getEnvironment();
    var itemId = env === 'production' ? 2197 : 730;
    applyService.setItemId(itemId);
    // 编辑用户报名信息的时候，需要userExamId定位提交的报名信息
    var userExamId = route.query.userExamId;
    if (userExamId) {
      userExamService.setUserExamId(+userExamId);
      userExamService.getUserExamDetail().then(function () {
        var _a, _b;
        var userExam = userExamService.userExam;
        if (userExam) {
          if (userExam.contestScheduleId) {
            applyService.formState.contestScheduleId = userExam.contestScheduleId;
            // 修改报名信息时先将 旧的报考组别ID存下来
            applyService.formState.oldContestScheduleId = userExam.contestScheduleId;
            // 修改报名信息，回显初始化出已选择的城市列表
            initAreaData();
          }
          var findGrade = (_b = (_a = applyService.item.regConfig) === null || _a === void 0 ? void 0 : _a.gradeInfoList) === null || _b === void 0 ? void 0 : _b.find(function (el) {
            return el.gradeId === userExam.grade;
          });
          var grade = findGrade ? userExam.grade : undefined;
          var classNameFlag = /^(?:[1-9][0-9]?|100)班$/.test(userExam.className);
          var cardType = userExam.cardType || undefined;
          return Object.assign(applyService.formState, userExam, {
            className: classNameFlag ? parseInt(userExam.className) : undefined,
            tempSchoolName: userExam.school,
            cardNo: applyService.formState.cardNo,
            area: userExam.areaIds || [],
            grade: grade || undefined,
            cardType: cardType
          });
        }
      });
    }
    var formState = computed(function () {
      return applyService.formState;
    });
    // 监听登录状态 现实情况应该无法走到 当前页面未登录 而需要去登录的情况
    var getHistoryFlag = false;
    watch(function () {
      return AuthConf;
    }, function (newAuthConf) {
      // 仅考虑登录状态 有品牌报名情况 无品牌回显数据 是一种异常情况
      if (newAuthConf.login && !getHistoryFlag) {
        applyService.getApplyInfoFromHistory().then(function () {
          getHistoryFlag = true;
        });
      }
    }, {
      immediate: true,
      deep: true
    });
    var inIframe = isInIframe();
    var phoneOnlyRead = computed(function () {
      var _a;
      // btoc里面特殊处理
      if (inIframe) {
        return false;
      }
      // 登录状态 手机号只读
      if (isLogin.value) {
        return true;
      } else {
        return ((_a = applyService.item) === null || _a === void 0 ? void 0 : _a.accountGenerateType) !== 2;
      }
    });
    var judeShowSchoolInfo = computed(function () {
      if (applyService.ConfClassName.show || applyService.ConfGrade.show || applyService.ConfArea.show || applyService.ConfTempSchoolName.show || applyService.ConfTeacherName.show) {
        return true;
      }
      return false;
    });
    var getCaptchaData = function (callback) {
      try {
        var captcha = new TencentCaptcha(CaptchaAppId, callback, {});
        captcha.show();
      } catch (e) {
        _message.error('图片验证码加载失败');
      }
    };
    var onSubmit = function () {
      formRef.value.validate().then(function () {
        var exParams = {};
        if (!phoneOnlyRead.value) {
          exParams = {
            verifyCode: applyService.formState.smsCode
          };
        }
        if (applyService.needAreaId) {
          exParams.areaId = applyService.formState.areaId;
        }
        if (!applyService.ConfMobile.required && !inIframe) {
          return new Promise(function (resolve, reject) {
            getCaptchaData(function cb(res) {
              if (res.ret === 0) {
                exParams.tencentCaptchaInfo = {
                  randStr: res.randstr,
                  ticket: res.ticket
                };
                resolve({
                  exParams: exParams
                });
              } else {
                reject();
              }
            });
          });
        }
        return {
          exParams: exParams
        };
      }).then(function (res) {
        return applyService.submit(userExamId, res.exParams).then(function (res) {
          // 判断在iframe中（b2c赛事联合）直接跳转个人中心
          if (userService.inIframe) {
            _message.success('报名成功');
            router.push({
              name: 'UserItemList'
            });
            return;
          }
          if ((res === null || res === void 0 ? void 0 : res.account) && (res === null || res === void 0 ? void 0 : res.password)) {
            loginInfo.visible = true;
            loginInfo.account = res.account;
            loginInfo.password = res.password;
          } else {
            _message.success(userExamId ? '修改报名信息成功' : '报名成功');
            router.push({
              name: 'UserItemList'
            });
          }
        });
      }).catch(function (e) {
        logger.debug('提交报名表单失败 => ', e);
      });
    };
    var applyToLogin = function (actType) {
      var actionLogin = function () {
        loginService.showLoginDialog();
        nextTick(function () {
          EventBusItemDetail.emit('refill-login-info', {
            account: loginInfo.account,
            password: loginInfo.password
          });
        });
      };
      var msgTips = '已成功复制账号密码，请妥善保存以免丢失';
      if (actType === 'saveImg') {
        var canvas = document.createElement('canvas');
        canvas.width = 300;
        canvas.height = 300;
        // 创建context对象
        var ctx = canvas.getContext('2d');
        if (ctx) {
          // 设置Canvas背景为白色
          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          // 设置字体样式
          ctx.font = '20px Arial';
          // 设置文字颜色
          ctx.fillStyle = '#333';
          // 水平居中
          ctx.textAlign = 'center';
          var title = "".concat(applyService.item.contestInfoName, "-").concat(applyService.item.contestItemName);
          var stepLen = Math.floor(canvas.width / 20) - 2;
          var stepCount = Math.ceil(title.length / stepLen);
          var posStartY = 50;
          // 获取Canvas的中心坐标
          var x = canvas.width / 2;
          for (var i = 0; i < stepCount; ++i) {
            ctx.fillText(title.slice(i * stepLen, i * stepLen + stepLen), x, posStartY + i * 24);
          }
          posStartY = posStartY + (stepCount - 1) * 24;
          ctx.font = '12px Arial';
          // 水平居左
          ctx.textAlign = 'left';
          // 设置文字颜色
          ctx.fillStyle = 'red';
          // 设置文字填充
          ctx.fillText('*', 10, posStartY + 25);
          // 设置文字颜色
          ctx.fillStyle = '#333';
          ctx.fillText('请务必自行妥善保存，避免遗失泄露', 20, posStartY + 25);
          ctx.font = '16px Arial';
          // 设置文字填充
          ctx.fillText("\u8D26\u53F7\uFF1A".concat(loginInfo.account), 10, posStartY + 60);
          // 设置文字颜色
          ctx.fillStyle = '#333';
          // 设置文字填充
          ctx.fillText("\u5BC6\u7801\uFF1A".concat(loginInfo.password), 10, posStartY + 90);
          // 水平居右
          ctx.font = '12px Arial';
          ctx.textAlign = 'right';
          // 设置文字颜色
          ctx.fillStyle = '#666';
          // 设置文字填充
          ctx.fillText("".concat(moment().format('YYYY-MM-DD HH:mm:ss')), canvas.width, posStartY + 120);
          saveAs(canvas.toDataURL('image/jpg', 1.0), "".concat(title, "-\u8D26\u5BC6.jpg"));
          canvas = null;
          msgTips = '已下载并复制账号密码，请妥善保存以免丢失';
        }
      }
      copyToClipboard("\u8D26\u53F7\uFF1A".concat(loginInfo.account, "\n      \u5BC6\u7801\uFF1A").concat(loginInfo.password)).then(function () {
        _message.success(msgTips);
        actionLogin();
      }).catch(function () {
        actionLogin();
      });
    };
    var initAreaData = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              // 加载一级地区
              return [4 /*yield*/, applyService.onContestScheduleIdChange()];
            case 1:
              // 加载一级地区
              _a.sent();
              setTimeout(function () {
                return __awaiter(_this, void 0, void 0, function () {
                  var areaIds, curretItem, curretSubItem;
                  var _a;
                  return __generator(this, function (_b) {
                    switch (_b.label) {
                      case 0:
                        areaIds = userExamService.userExam.areaIds || [];
                        curretItem = applyService.areaList.find(function (item) {
                          return item.id === areaIds[0];
                        });
                        if (!curretItem) return [3 /*break*/, 3];
                        // 加载二级地区
                        return [4 /*yield*/, applyService.loadAreaData([curretItem])];
                      case 1:
                        // 加载二级地区
                        _b.sent();
                        curretSubItem = (_a = curretItem === null || curretItem === void 0 ? void 0 : curretItem.children) === null || _a === void 0 ? void 0 : _a.find(function (item) {
                          return item.id === areaIds[1];
                        });
                        if (!curretSubItem) return [3 /*break*/, 3];
                        // 加载三级地区
                        return [4 /*yield*/, applyService.loadAreaData([curretSubItem])];
                      case 2:
                        // 加载三级地区
                        _b.sent();
                        _b.label = 3;
                      case 3:
                        return [2 /*return*/];
                    }
                  });
                });
              }, 1000);
              return [2 /*return*/];
          }
        });
      });
    };
    // 获取
    applyService.getAllScheduleList();
    EventBusItemDetail.on('login-success', function () {
      isLogin.value = getToken();
      router.push({
        name: 'UserItemList'
      });
    });
    var regPageConfig = computed(function () {
      return applyService.item.regPageConfig || {};
    });
    return {
      applyService: applyService,
      userExamService: userExamService,
      formState: formState,
      formRef: formRef,
      router: router,
      isLogin: isLogin,
      userExamId: userExamId,
      onSubmit: onSubmit,
      PersonalComList: PersonalComList,
      SchoolComList: SchoolComList,
      applyToLogin: applyToLogin,
      loginInfo: loginInfo,
      judeShowSchoolInfo: judeShowSchoolInfo,
      regPageConfig: regPageConfig
    };
  },
  provide: function () {
    return {
      formRef: this.formRef,
      isLogin: this.isLogin
    };
  }
});